var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlanet({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_8948)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.33398 8.99967C2.33398 12.6817 5.31865 15.6663 9.00065 15.6663C12.6827 15.6663 15.6673 12.6817 15.6673 8.99967C15.6673 5.31767 12.6827 2.33301 9.00065 2.33301C5.31865 2.33301 2.33398 5.31767 2.33398 8.99967Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.66724 2.36621C9.66724 2.36621 11.6672 4.99954 11.6672 8.99954C11.6672 12.9995 9.66724 15.6329 9.66724 15.6329M8.33391 15.6329C8.33391 15.6329 6.33391 12.9995 6.33391 8.99954C6.33391 4.99954 8.33391 2.36621 8.33391 2.36621M2.75391 11.3329H15.2472M2.75391 6.66621H15.2472",
    stroke: "currentColor",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_8948"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(1 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanet);
export default __webpack_public_path__ + "static/media/planet.fc274e0f82fc1b863b6494cb4a7381a4.svg";
export { ForwardRef as ReactComponent };